import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/mui";
import { Alert, Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import {
    AttachmentGallery,
    DetailSection,
    FieldGrid,
    FieldItem,
    getAttachedUrls,
} from "components/detail";

export const ExpenseShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading, isError } = queryResult;

    const navigate = useNavigate();

    const record = data?.data;

    return (
        <Show
            isLoading={isLoading}
            title={
                <Typography variant="h5">
                    현장요원경비 상세{record?.id ? ` · ${record.id}` : ""}
                </Typography>
            }
            headerButtons={({ defaultButtons }) => (
                <>
                    {defaultButtons}
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            navigate("/expenses/files/" + record?.id);
                        }}
                    >
                        첨부파일 수정
                    </Button>
                </>
            )}
        >
            {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    현장요원경비를 불러오지 못했습니다.
                </Alert>
            )}

            <Stack spacing={2}>
                <DetailSection title="기본 정보">
                    <FieldGrid columns={2}>
                        {/* 원본: record?.agent.name + "-" + record?.agent.code */}
                        <FieldItem
                            label="현장요원"
                            value={
                                record?.agent
                                    ? `${record.agent.name}-${record.agent.code}`
                                    : undefined
                            }
                        />
                        <FieldItem label="방문일" value={record?.date} />
                        <FieldItem label="자차여부" value={record?.hasCar} />
                    </FieldGrid>
                </DetailSection>

                <DetailSection title="비용">
                    <FieldGrid columns={2}>
                        <FieldItem label="우편료" value={record?.post} />
                        <FieldItem label="유류비" value={record?.gas} />
                        <FieldItem label="주차비" value={record?.parking} />
                        <FieldItem label="톨비" value={record?.toll} />
                        <FieldItem label="기타" value={record?.etc} />
                    </FieldGrid>
                </DetailSection>

                <DetailSection title="기타">
                    <FieldGrid columns={2}>
                        <FieldItem
                            label="비고"
                            span={2}
                            multiline
                            value={record?.comment}
                        />
                        <FieldItem label="수정일" value={record?.updatedAt} />
                    </FieldGrid>
                </DetailSection>

                <DetailSection title="첨부 파일">
                    <AttachmentGallery items={getAttachedUrls(record)} />
                </DetailSection>
            </Stack>
        </Show>
    );
};
